import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@/react/components/shared/BuilderUI";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useOnClickToggleSection } from "../Hooks/useOnClickToggleSection";
import type { ButtonProps } from "./Button";

export interface LayersButtonProps extends ButtonProps {
  shouldKeepSidebarOpen?: boolean;
}

export const LayersButton = ({
  shouldKeepSidebarOpen = false,
  className,
  ...rest
}: LayersButtonProps) => {
  const onClickHandler = useOnClickToggleSection({
    viewName: "layers",
    shouldKeepSidebarOpen,
  });

  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);
  const isLayersActive = actionSidebarView === "layers";

  return (
    <IconButton
      name={isLayersActive ? "24-layers-2-filled" : "24-layers-2"}
      iconSize={24}
      buttonSize={32}
      ariaLabel={t("builder_ui.layers.title")}
      tooltipText={t("builder_ui.layers.title")}
      tooltipPosition="right"
      className={classNames(className, {
        "bg-tertiary": isLayersActive,
      })}
      onClick={onClickHandler}
      iconClassName="!text-dark"
      data-testid="builder-ui-layers-button"
      {...rest}
    />
  );
};
